// Static configuration used across application
export const ORGANISATION_OWNER = 'ORGANISATION_OWNER';
export const ORGANISATION_ADMIN = 'ORGANISATION_ADMIN';
export const ORGANISATION_MEMBER = 'ORGANISATION_MEMBER';

export const CAMPAIGN_OWNER = 'CAMPAIGN_OWNER';
export const CAMPAIGN_ADMIN = 'CAMPAIGN_ADMIN';
export const TEAM_MEMBER = 'TEAM_MEMBER';
export const CLIENT = 'CLIENT';
export const INFLUENCER = 'INFLUENCER';
export const TALENT_AGENT = 'TALENT_AGENT';
export const PRODUCTION_COMPANY = 'PRODUCTION_COMPANY';
export const PARTNER_AGENCY = 'PARTNER_AGENCY';

export const DOCUMENT = 'DOCUMENT';
export const BRIEF = 'BRIEF';
export const CONTRACT = 'CONTRACT';
export const DELIVERABLE = 'DELIVERABLE';
export const DELIVERABLE_SET = 'DELIVERABLE_SET';
export const DELIVERABLE_SUBMIT = 'DELIVERABLE_SUBMIT';
export const SIGNED_CONTRACT = 'SIGNED_CONTRACT';
export const TRACKED_ASSET = 'TRACKED_ASSET';
export const SUPPORTING_FILE = 'SUPPORTING_FILE';
export const ENGAGEMENT_SCORE = 'ENGAGEMENT_SCORE';
export const ELEMIS_REPORT = 'ELEMIS_REPORT';


export const FACEBOOK = 'FACEBOOK';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const TIKTOK = 'TIKTOK';
export const TWITTER = 'TWITTER';
export const SNAPCHAT = 'SNAPCHAT';
export const TELEGRAM = 'TELEGRAM';
export const VK = 'VK';

export const VIDEO = 'VIDEO';
export const IMAGE = 'IMAGE';
export const TEXT = 'TEXT';
export const BLOG = 'BLOG';
export const OTHER = 'OTHER';

export const ACTIVE = 'ACTIVE';
export const ARCHIVED = 'ARCHIVED';

export const ASSIGNED = 'ASSIGNED';
export const ADDED = 'ADDED';
export const APPROVED = 'APPROVED';

export const YOUTUBE_WATCH_URL = 'https://www.youtube.com/watch?v=';

export const DISCUSSION_PAGE = 'DISCUSSION_PAGE';
export const DELIVERABLE_PAGE = 'DELIVERABLE_PAGE';

// File types
export const YOUTUBE_URL = 'YOUTUBE_URL';
export const IMAGE_URL = 'IMAGE_URL';
export const FILE_URL = 'FILE_URL';
export const PDF_URL = 'PDF_URL';
export const DOC_URL = 'DOC_URL';
export const EXTERNAL_URL = 'EXTERNAL_URL';
export const TEXT_CONTENT = 'TEXT_CONTENT';

export const ALL = 'ALL';
export const MILESTONES = 'MILESTONES';
export const NONE = 'NONE';

export const INSTANTLY = 'INSTANTLY';
export const HOURLY = 'HOURLY';
export const DAILY = 'DAILY';

export const USER = 'USER';
export const CAMPAIGN = 'CAMPAIGN';

export const COLLABORATIONS = 'COLLABORATIONS';
export const ANALYTICS = 'ANALYTICS';
export const PAYMENTS = 'PAYMENTS';
export const GROUP_CHATS = 'GROUP_CHATS';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const AUDIT_TRAIL = 'AUDIT_TRAIL';

export const SEND_BRIEF_ALL = 'SEND_BRIEF_ALL';
export const SEND_DELIVERABLE_ALL = 'SEND_DELIVERABLE_ALL';
export const UPLOAD_SUPPORTING_FILE = 'UPLOAD_SUPPORTING_FILE';
export const LS_PER_PAGE_KEY = 'pp-key';



/** WEBPACK FOOTER **
 ** ./src/utils/static-configuration.js
 **/